module.exports = __webpack_public_path__ + "images/backgrounds/canyon/full.0c35d8049641c307de51.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/canyon/full.jpg
// module id = MbhK
// module chunks = 12